import { render, staticRenderFns } from "./index.html?vue&type=template&id=42872586&scoped=true&external"
import script from "./copy.js?vue&type=script&lang=js&external"
export * from "./copy.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=42872586&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42872586",
  null
  
)

export default component.exports